<template>
    
    <div>
        <el-form ref="projectForm" style="text-align:left;width:500px;margin:0 auto;" :model="projectForm" :rules="projectRules" class="project-form" auto-complete="on" label-width="120px">
    <!-- 项目名称 -->
		<div v-if="active==0">
            <el-form-item :label="$t('project.proName')" prop="project_name">
                <el-input v-model="projectForm.project_name" :placeholder="$t('project.unInputProject')" name="ProjectName" type="text" auto-complete="on" />
            </el-form-item>
			<!-- 项目负责人 -->
			<el-form-item :label="$t('project.propriname')" prop="project_principal_name">
			    <el-input v-model="projectForm.project_principal_name" :placeholder="$t('project.unInputpropriname')" name="Propriname" type="text" auto-complete="on" />
			</el-form-item>
			<!-- 项目负责人电话 -->
			<el-form-item :label="$t('project.propritel')" prop="project_principal_tel">
			    <el-input v-model="projectForm.project_principal_tel" :placeholder="$t('project.unInputpropritel')" name="Propritel" type="text" auto-complete="on" />
			</el-form-item>
    <!-- 物业名称 -->
            <el-form-item :label="$t('project.propertyName')" prop="property">
                <el-input type="text" v-model="projectForm.property" :placeholder="$t('project.unInputProperty')" name="property" auto-complete="on" />
            </el-form-item>
			<!-- 物业负责人 -->
			<el-form-item :label="$t('project.perpriname')" prop="property_principal_name">
			    <el-input type="text" v-model="projectForm.property_principal_name" :placeholder="$t('project.unInputperpriname')" name="Perpriname" auto-complete="on" />
			</el-form-item>
			<!-- 物业负责人电话 -->
			<el-form-item :label="$t('project.perpritel')" prop="property_tel">
			    <el-input type="text" v-model="projectForm.property_tel" :placeholder="$t('project.unInputperpritel')" name="Perpritel" auto-complete="on" />
			</el-form-item>
    <!-- 系统类型 -->
<!--            <el-form-item :label="$t('project.systemType')">
                <el-select v-model="projectForm.sysid" :placeholder="$t('project.unInputProjectType')" name="sysid" :disabled="isEdit">
                    <el-option
                        v-for="v in systemType"
                        :key="v.value"
                        :disabled="v.disable"
                        :label="v.label"
                        :value="v.value">
                    </el-option>
                </el-select>
            </el-form-item> -->
    <!-- 经销商/业务员 -->
            <!-- <el-form-item :label="$t('project.salename')" prop="salename">
                <el-input type="text" v-model="projectForm.salename" :placeholder="$t('project.unInputSalename')" name="Salename" auto-complete="on" />
            </el-form-item> -->
    <!-- 电话号码 -->
            <!-- <el-form-item :label="$t('project.telphone')" prop="telphone">
                <el-input type="text" v-model="projectForm.telphone" :placeholder="$t('project.unInputTelphone')" name="Telphone" auto-complete="on" />
            </el-form-item> -->
    <!-- 所属地区 -->
            <el-form-item :label="$t('project.regions')" prop="dist">
                <el-select class="regions-select" :disabled="isEdit" v-model="projectForm.province" @change="handleProChange" :placeholder="$t('project.province')">
                    <el-option
                    v-for="item in Province"
                    :key="item.oid"
                    :label="item.name"
                    :value="item.oid"
                    >
                    </el-option>
                </el-select>
                <el-select class="regions-select" :disabled="isEdit" v-model="projectForm.city" :placeholder="$t('project.city')" @change="handleCityChange">
                    <el-option
                    v-for="item in City"
                    :key="item.oid"
                    :label="item.name"
                    :value="item.oid"
                    >
                    </el-option>
                </el-select>
                <el-select class="regions-select" :disabled="isEdit" v-model="projectForm.dist" :placeholder="$t('project.country')"  @change="handleCountryChange">
                    <el-option
                    v-for="item in Country"
                    :key="item.oid"
                    :label="item.name"
                    :value="item.oid"
                   >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('project.address')" prop="address">
               <el-input v-model="projectForm.address" :disabled="isEdit" :placeholder="$t('project.unInputAddress')" @blur="handleAddressBlur" name="Address" type="text"/>
            </el-form-item>
    <!-- 建筑类型 -->
            <el-form-item :label="$t('project.projectType')" prop="buildings_template_id">
                <el-select v-model="projectForm.buildings_template_id" :placeholder="$t('project.unInputProjectType')" name="buildings_template_id" :disabled="isEdit">
                    <el-option v-for="(item, index) in baseData.tmpProject" :key="index" :label="item.typename" :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
    <!-- 计费方案 -->
            <!-- <el-form-item :label="$t('project.chargescheme')" v-if="projectForm.sysid===0" prop="default_statistic_rule">
                <el-select v-model="projectForm.default_statistic_rule" 
                    name="DefaultStatisticRule"
                    :placeholder="$t('project.unInputChargeScheme')" 
                    :disabled="isEdit">
                    <el-option v-for="(item, index) in baseData.chargeScheme" 
                        :key="index" 
                        :label="item.RuleName" 
                        :value="item.OID"
                        :disabled="item.UsableType==2">
                    </el-option>
                </el-select>
                <el-button v-if="!isEdit && projectForm.DefaultStatisticRule" @click="handleOpenCharge" style="margin-left:15px;" type="text">点击查看方案详情</el-button>
            </el-form-item> -->
    <!-- 项目头像 -->
            <el-form-item label="LOGO" prop="icon">
                <el-upload class="avatar-uploader" 
                    :action="UploadUrl" 
                    :show-file-list="false" 
                    accept="image/*" 
                    :on-success="handleAvatarSuccess" 
                    :on-progress="uploadVideoProcess"
                    :headers="headers"
                    name="image"
                    :before-upload="beforeAvatarUpload" style="text-align: left">
                    <img v-if="projectForm.icon" :src="projectForm.icon" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <el-progress v-if="videoUploadPercent>0 && videoUploadPercent<100" type="circle" width="50" :percentage="videoUploadPercent" class="upload-progress"></el-progress>
                </el-upload>
            </el-form-item>
    <!-- 备注 -->
            <el-form-item :label="$t('project.remark')">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="150" name="description" v-model="projectForm.description"></el-input>
            </el-form-item>
			</div>
            <div class="btn-container">
                <el-button class="btn" v-loading="loading" type="primary" @click.native.prevent="submitProject">{{ $t('btns.sure') }}</el-button>
            </div>
        </el-form>

        <!-- 方案详情弹框 -->
        <div>
            <cmp-scheme-detail :show.sync="show" :modelData="schemeDetail" ></cmp-scheme-detail>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from '@/config'
import Storage from '@/utils/storage'
import Service from '@/api/Service'
import { SYSTEMTYPE } from '@/api/configData'
import stringUtils from '@/utils/stringUtils'
import CmpSchemeDetail from '@/views/BaseConfigMana/SetBaseChargeScheme/ChargeSchemeList/CmpSchemeDetail'
export default {
    name: "projectform",
    props: ["editData"],
    inject: ['handleEdit'],
    data() {
        //  验证手机号+电话号码
        const checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("电话号码不能为空"));
            } else {
                if (stringUtils(value).isMobilePhone() || stringUtils(value).isTelPhone()) {
                    callback();
                } else {
                     return callback(new Error("电话号码格式有误"));
                }
            }
        };
        return {
            // 项目表单信息
            projectForm: {
                project_name: "",
                property: "",
				project_principal_name:'',//项目负责人
				property_principal_name:'',//物业负责人
				project_principal_tel:'',//项目负责人电话
				property_tel:'',//物业电话
                buildings_template_id: '',     //  建筑类型
                sysid: 0,     //  系统类型
                // salename: "",
                // telphone: "",
                country: '中国',
                province: '',
                city: '',
                dist: '',
                address: '',
                icon: '',
                // default_statistic_rule: '',     // 计费策略
                description:'',
                longitude: '',
                latitude: '',
            },
            // 表单验证
            projectRules: {
                // 项目名称
                project_name: [{ required: true, trigger: "blur", message: this.$t("project.unInputProject") }],
				// 项目负责人电话
				project_principal_name: [{ required: true, trigger: "blur", message: this.$t("project.unInputpropriname") }],
				// 项目负责人电话
				project_principal_tel: [{ required: true, trigger: "blur", message: this.$t("project.unInputpropritel") }],
                // 物业名称
                property: [{ required: true, trigger: "blur", message: this.$t("project.unInputProperty") }],
				// 物业负责人
				property_principal_name: [{ required: true, trigger: "blur", message: this.$t("project.unInputperpriname") }],
				// 物业负责人电话
				property_tel: [{ required: true, trigger: "blur", message: this.$t("project.unInputperpritel") }],
                // 建筑类型
                buildings_template_id: [{ required: true, trigger: "change", message: this.$t("project.unInputProjectType") }],
                // // 	经销商/业务员
                // salename: [{ required: true, trigger: "blur", message: this.$t("project.unInputSalename")} ],
                // // 电话
                // telphone: [{ required: true, trigger: "blur", validator: checkPhone }],
                // 省、市、区
                dist: [{ required: true, trigger: "change", message: this.$t("project.unInputRegions") }],
                // 计费策略
                // default_statistic_rule: [{ required: true, trigger: "change", message: this.$t("project.unInputChargeScheme") }],
            },

            UploadUrl: config.UPLOAD_URL,
            videoUploadPercent: 0,

            loading: false,
            lang: localStorage.getItem("lang") || "cn",
            
            // 方案详情
            show: false,
            schemeDetail: {},
            systemType: SYSTEMTYPE,

            // 区域
            Province: [],
            City: [],
            Country: [],
            ProvinceName: '',
            CityName: '',
            DistName: '',
			active:0,
        };
    },
    components: {
        CmpSchemeDetail
    },
    created() {
        this.initProjectData();
        // 获取项目模型列表
        this.$store.dispatch("getTemplateList");
        // 获取方案列表
        // this.$store.dispatch("getChargeScheme");

        this.getProvince();
    },
    watch: {
        editData(newData) {
            if (newData) {
                this.initProjectData();
            }
        }
    },
    computed: {
        // 是否是创建项目
        isEdit() {
            return JSON.stringify(this.editData) != '{}'
        },
        ...mapGetters(["baseData"]),
        headers() {
            let token = Storage.get('token');
            if (token) {
                return { Authorization: token.token };
            }else{
                return {}
            }
        }
    },
    methods: {
        // 初始化数据
        initProjectData() {
            if (JSON.stringify(this.editData) != '{}') {
                this.projectForm = Object.assign(
                    {},
                    this.projectForm,
                    this.editData
                );
            }
        },
        // 图片上传成功后返回地址
        handleAvatarSuccess(res) {
            if(res.status == 20001000) {
                this.projectForm.icon = config.DEFAULT_FILE_PATH + res.data;
            }else{
                this.$message.error(res.message);
            }
        },
        uploadVideoProcess(event, file, fileList){
            this.videoUploadPercent = file.percentage.toFixed(0);
        },
        // 上传LOGO
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isLt2M;
        },
        // 确认提交
        submitProject() {
            this.$refs.projectForm.validate(valid => {
                if (valid) {
                    if(JSON.stringify(this.editData) != '{}'){
                        // 编辑项目
                        this.editProject();
                    }else{
                        this.projectForm.province= this.ProvinceName;
                        this.projectForm.city = this.CityName;
                        this.projectForm.dist = this.DistName;
                        // 新建项目
                        this.addProject();
                    }
                }
            });
        },
        async editProject() {
            let data = await Service.editProject(this.projectForm);
            if(data){
                this.$message({
                    message: '更新成功',
                    type: 'success',
                    duration: 2000,
                    onClose: () => {
                        this.handleEdit();
                    }
                });
            }
        },
        async addProject() {
            let data = await Service.addProject(this.projectForm);
            if(data){
                this.$message({
                    message: '新增成功',
                    type: 'success',
                    duration: 2000,
                    onClose: () => {
                        this.$router.push('/projectlist')
                    }
                });
            }
        },
        // 查看方案详情
        // handleOpenCharge() {
        //     let data = this.baseData.chargeScheme.filter(v=>{
        //         return  v.OID === this.projectForm.default_statistic_rule
        //     })
        //     this.show = true;
        //     this.schemeDetail = data[0];
        // },
        // 选择地区
        async getProvince() {
            let res = await Service.getProvince();
            if(res){
                this.Province = res;
            }
        },
        // 选择地区
        async handleProChange(val) {
            let item = this.Province.filter(v=>{return v.oid === val});
            let res = await Service.getCity({oid: val});
            if(res){
                this.City = res;
                this.ProvinceName = item[0].name;
                this.projectForm.city = "";
                this.projectForm.dist = "";
                this.cityName = "";
                this.DistName = "";
                
            }
        },
        async handleCityChange(val) {
            let item = this.City.filter(v=>{return v.oid === val})
            let res = await Service.getCountry({oid: val});
            if(res){
                this.Country = res;
                this.CityName = item[0].name;
                this.projectForm.dist = "";
                this.DistName = "";
            }
        },
        async handleCountryChange(val) {
            let item = this.Country.filter(v=>{return v.oid === val})
            this.DistName = item[0].name;
            this.getCoordinate();
        },
        handleAddressBlur(val) {
            this.getCoordinate();
        },
        // 获取经纬度
        async getCoordinate() {
            let address = this.ProvinceName + this.CityName + this.DistName + this.projectForm.address
            let res = await Service.getCoordinate({ address });
            if(res) {
                this.projectForm.longitude = res.longitude;
                this.projectForm.latitude = res.latitude;
            }
        }
    }
};
</script>
<style lang="less">
.upload-progress{
    position: absolute;
    z-index: 99;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
}
.avatar-uploader .el-upload{
    position: relative;
    line-height: 0;
}
.avatar-uploader .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: @primary-color;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 120px;
    height: 120px;
    display: block;
}
.project-form .btn {
    margin: 24px 80px 0 80px;
    width: calc(100% - 80px);
}
.project-form-edit .project-form .btn{
    width: calc(100% - 150px);
}

.regions-select{
    width: 120px;
    &:nth-child(2){
        margin: 0 10px;
    }
}
</style>
